export var selectSavedOfferId = function selectSavedOfferId(state) {
  return state.favoritesAssignWidget.savedOfferId;
};